// extracted by mini-css-extract-plugin
module.exports = {"badge":"ConcreteQualityBadge_badge__3I3kP"};